import { ActionReducerMap } from '@ngrx/store';

import { recordsReducer } from '@reducers/records/records.reducer';
import { tasksReducer } from '@reducers/tasks/tasks.reducer';
import { uploadsReducer } from '@reducers/uploads/uploads.reducer';

import {
    authenticationReducer,
    oauthReducer,
    SearchOptionsReducer,
    selectionReducer,
    toastReducer,
    tokenReducer,
    userPreferencesReducer,
    userReducer,
    verifierReducer,
    ViewOptionsReducer
} from '@mediahaven/shared';
import { ApplicationState } from 'state';

export const rootReducer: ActionReducerMap<ApplicationState> = {
    authentication: authenticationReducer,
    selection: selectionReducer,
    token: tokenReducer,
    toast: toastReducer,
    user: userReducer,
    userPreferences: userPreferencesReducer,
    uploadItem: uploadsReducer,
    task: tasksReducer,
    viewOptions: ViewOptionsReducer,
    searchOptions: SearchOptionsReducer,
    oauth: oauthReducer,
    records: recordsReducer,
    verifier: verifierReducer
};
